const KEY = {
  justNow: "TIME_JUST_NOW",
  minute: "TIME_MINUTE_AGO",
  minutes: "TIME_MINUTES_AGO",
  hour: "TIME_HOUR_AGO",
  hours: "TIME_HOURS_AGO",
  day: "TIME_DAY_AGO",
  days: "TIME_DAYS_AGO",
  month: "TIME_MONTH_AGO",
  months: "TIME_MONTHS_AGO",
  year: "TIME_YEAR_AGO",
  years: "TIME_YEARS_AGO",
  inMinute: "TIME_IN_MINUTE",
  inMinutes: "TIME_IN_MINUTES",
  inHour: "TIME_IN_HOUR",
  inHours: "TIME_IN_HOURS",
  inDay: "TIME_IN_DAY",
  inDays: "TIME_IN_DAYS",
  inMonth: "TIME_IN_MONTH",
  inMonths: "TIME_IN_MONTHS",
  inYear: "TIME_IN_YEAR",
  inYears: "TIME_IN_YEARS"
};
let configuredPrefix = "";
const configureRelativeTime = (options) => {
  if (typeof options?.keyPrefix === "string") {
    configuredPrefix = options.keyPrefix;
  }
};
const translate = (suffix, fallback, count) => {
  let text = fallback;
  try {
    const registry = globalThis?.window?.Joomla?.Text;
    if (registry && typeof registry._ === "function") {
      const key = configuredPrefix + suffix;
      const resolved = registry._(key, fallback);
      if (typeof resolved === "string" && resolved !== "" && resolved !== key) {
        text = resolved;
      }
    }
  } catch {
    text = fallback;
  }
  if (count !== void 0) {
    text = text.replace(/%1\$[sd]/g, String(count)).replace(/%[sd]/g, String(count));
  }
  return text;
};
const humanReadableDate = (dateString, options) => {
  if (!dateString) {
    return "";
  }
  try {
    const date = dateString instanceof Date ? dateString : new Date(dateString);
    if (isNaN(date.getTime())) {
      console.warn(`Invalid date string: ${dateString}`);
      return "";
    }
    const previousPrefix = configuredPrefix;
    if (typeof options?.keyPrefix === "string") {
      configuredPrefix = options.keyPrefix;
    }
    try {
      return describeDistance(date);
    } finally {
      configuredPrefix = previousPrefix;
    }
  } catch (error) {
    console.warn(`Error parsing date: ${dateString}`, error);
    return "";
  }
};
const formatAbsoluteDate = (value, options = { year: "numeric", month: "long", day: "numeric" }) => {
  if (!value) {
    return "";
  }
  try {
    const date = value instanceof Date ? value : new Date(value);
    if (isNaN(date.getTime())) {
      return "";
    }
    return date.toLocaleDateString(documentLocale(), options);
  } catch {
    return "";
  }
};
const documentLocale = () => {
  try {
    const lang = globalThis?.document?.documentElement?.lang;
    return typeof lang === "string" && lang !== "" ? lang : void 0;
  } catch {
    return void 0;
  }
};
const describeDistance = (date) => {
  const deltaMs = Date.now() - date.getTime();
  const future = deltaMs < 0;
  const sec = Math.round(Math.abs(deltaMs) / 1e3);
  if (sec < 45) {
    return translate(KEY.justNow, "just now");
  }
  if (sec < 90) {
    return future ? translate(KEY.inMinute, "in 1 minute") : translate(KEY.minute, "1 minute ago");
  }
  const min = Math.round(sec / 60);
  if (min < 45) {
    return future ? translate(KEY.inMinutes, `in ${min} minutes`, min) : translate(KEY.minutes, `${min} minutes ago`, min);
  }
  if (min < 90) {
    return future ? translate(KEY.inHour, "in about 1 hour") : translate(KEY.hour, "about 1 hour ago");
  }
  const hr = Math.round(min / 60);
  if (hr < 24) {
    return future ? translate(KEY.inHours, `in about ${hr} hours`, hr) : translate(KEY.hours, `about ${hr} hours ago`, hr);
  }
  if (hr < 42) {
    return future ? translate(KEY.inDay, "in 1 day") : translate(KEY.day, "1 day ago");
  }
  const day = Math.round(hr / 24);
  if (day < 30) {
    return future ? translate(KEY.inDays, `in ${day} days`, day) : translate(KEY.days, `${day} days ago`, day);
  }
  if (day < 45) {
    return future ? translate(KEY.inMonth, "in about 1 month") : translate(KEY.month, "about 1 month ago");
  }
  const mon = Math.round(day / 30);
  if (mon < 12) {
    return future ? translate(KEY.inMonths, `in about ${mon} months`, mon) : translate(KEY.months, `about ${mon} months ago`, mon);
  }
  if (mon < 18) {
    return future ? translate(KEY.inYear, "in about 1 year") : translate(KEY.year, "about 1 year ago");
  }
  const yr = Math.round(mon / 12);
  return future ? translate(KEY.inYears, `in about ${yr} years`, yr) : translate(KEY.years, `about ${yr} years ago`, yr);
};
export {
  configureRelativeTime,
  formatAbsoluteDate,
  humanReadableDate
};
//# sourceMappingURL=date-utils.js.map
